module.exports = __webpack_public_path__ + "img/pause2.759f12c9.svg";